
export const big_propellant = 12000000;
export const medium_propellant = 4000000;
export const small_propellant = 1000000;

